import { useState } from "react";

const PasswordInput = ({ className = "", ...inputProps }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative">
      <input
        {...inputProps}
        type={isVisible ? "text" : "password"}
        className={`${className} pr-11`}
      />
      <button
        type="button"
        aria-label={isVisible ? "Hide password" : "Show password"}
        aria-pressed={isVisible}
        onClick={() => setIsVisible((visible) => !visible)}
        className="absolute inset-y-0 right-0 flex w-10 items-center justify-center rounded-r-md text-zinc-500 hover:bg-zinc-100 hover:text-zinc-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-zinc-400"
      >
        <svg
          aria-hidden="true"
          className="h-5 w-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z" />
          <circle cx="12" cy="12" r="3" />
          {!isVisible && <path d="m4 4 16 16" />}
        </svg>
      </button>
    </div>
  );
};

export default PasswordInput;
